import { TeamModel } from "./Team";

export class TeamScoreModel extends TeamModel{
    public wins: number = 0;
    public losses: number = 0;
    public homes: number = 0;
    public errors: number = 0;
    public runs: number = 0;
    public activities: {
        title: string,
        movements: {
            label: string,
            value: string
        }[]
    }[] = [];

    constructor(obj?: any) {
        super(obj);
        if (obj) {
        }
    }
}